/**
 * SSE资源回调
 */
export class SSEResponse {
    id?: number;
    model?: string;
    object?: string;
    choices?: {
        index?: number,
        delta?: {
            content: string
        },
        finish_reason: string | "stop"
    }[];
    usage?: {
        prompt_tokens?: number,
        completion_tokens?: number,
        total_tokens?: number
    };
    created?: number;
}